document.addEventListener('DOMContentLoaded', function () {
  const optionButtons = document.querySelectorAll('.variant-option-button');
  console.log('Option Buttons:', optionButtons);

  if (optionButtons.length === 0) {
    console.warn('No buttons found with the class "variant-option-button".');
    return;
  }

  const variants = window.ShopifyAnalytics.meta.product.variants;
  let selectedOptions = {};

  optionButtons.forEach(button => {
    button.addEventListener('click', function () {
      console.log('Button clicked:', this);

      const optionName = this.getAttribute('data-option-name');
      const optionValue = this.getAttribute('data-option-value');
      console.log('Selected Option:', { optionName, optionValue });

      // Store selected option
      selectedOptions[optionName] = optionValue;

      // Update button active state
      document.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      // Find the matching variant
      const matchingVariant = findMatchingVariant(selectedOptions);
      if (matchingVariant) {
        console.log('Matching Variant:', matchingVariant);
        updateProductDetails(matchingVariant);
      } else {
        console.warn('No matching variant found');
      }

      // Update button availability
      updateButtonStates(selectedOptions);
    });
  });

  function findMatchingVariant(selectedOptions) {
    return variants.find(variant => {
      const variantTitleParts = variant.public_title.split(' / ');
      return Object.values(selectedOptions).every((selectedValue, index) => {
        return variantTitleParts[index] === selectedValue;
      });
    });
  }

  function updateProductDetails(variant) {
    const priceElement = document.querySelector('.s-product__price span');
    if (priceElement) {
      priceElement.innerHTML = formatMoney(variant.price, '{{ shop.currency }}');
    }

    const imagesGrid = document.querySelector('.s-product__images-grid');
    if (imagesGrid && variant.featured_image) {
      imagesGrid.innerHTML = `<img src="${variant.featured_image.src}" alt="${variant.featured_image.alt}" />`;
    }

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variant.id;
      console.log('Updated variant ID:', variant.id);
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.pushState({ path: url.href }, '', url.href);
  }

  function updateButtonStates(selectedOptions) {
    optionButtons.forEach(button => {
      const optionName = button.getAttribute('data-option-name');
      const optionValue = button.getAttribute('data-option-value');

      const isValid = variants.some(variant => {
        const variantTitleParts = variant.public_title.split(' / ');
        return Object.keys(selectedOptions).every((name, index) => {
          const selectedValue = selectedOptions[name];
          return (
            name !== optionName
              ? variantTitleParts[index] === selectedValue
              : variantTitleParts[index] === optionValue
          );
        });
      });

      if (isValid) {
        button.classList.remove('disabled');
        button.disabled = false;
      } else {
        button.classList.add('disabled');
        button.disabled = true;
      }
    });
  }

  function formatMoney(amount, format) {
    const options = {
      style: 'currency',
      currency: 'USD', // Change to your store's currency
      minimumFractionDigits: 2,
    };

    if (typeof amount !== 'number') {
      amount = parseInt(amount, 10);
    }

    const formatter = new Intl.NumberFormat('en-US', options); // Adjust 'en-US' as needed
    return formatter.format(amount / 100); // Shopify stores prices as cents
  }
});